import { WidgetSize, WidgetType } from 'components/farm-dashboard/types'
import { LicensesType } from 'models/IUserData'

export const CATTLES_WIDGETS = [
	{
		id: WidgetType.IDENTIFICATE,
		type: WidgetType.IDENTIFICATE,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.IDENTIFICATE_WITH_NOTIF_MEDIUM,
		type: WidgetType.IDENTIFICATE_WITH_NOTIF_MEDIUM,
		size: WidgetSize.MEDIUM,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.HERD_ALL,
		type: WidgetType.HERD_ALL,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.LARGE_HERD_STRUCTURE,
		type: WidgetType.LARGE_HERD_STRUCTURE,
		size: WidgetSize.LARGE,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.HERD_STRUCTURE,
		type: WidgetType.HERD_STRUCTURE,
		size: WidgetSize.MEDIUM,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.MILKY_HERD,
		type: WidgetType.MILKY_HERD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.DRY_HERD,
		type: WidgetType.DRY_HERD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
]
